import { render, staticRenderFns } from "./FavoritesPage.vue?vue&type=template&id=21243bfc&"
import script from "./FavoritesPage.vue?vue&type=script&lang=js&"
export * from "./FavoritesPage.vue?vue&type=script&lang=js&"
import style0 from "./FavoritesPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports